/**
 * Taken from EsteeLauder.
 * Modifications: changed the image path for SBX and moved inline styles to CSS file.
 */

(function($, Drupal, ServiceBus, Topics) {
  'use strict';

  if (window.self !== window.top) {
    return;
  }

  if (!ServiceBus || typeof ServiceBus.on !== 'function') {
    return;
  }

  if (!Topics.events || !Topics.events.FINDATION_BUTTON_CLICKED) {
    return;
  }

// Preload spinner image so it's cached.
  new Image().src = '/sites/smashbox/themes/smashbox_base/img/animated-loader.svg';

  const findationButtonSelector = '.js-third-party-tout-findation-cta .js-mantle-cta-button';
  const findationSpinnerMarkup = '<img class="findation-loading-spinner" src="/sites/smashbox/themes/smashbox_base/img/animated-loader.svg" alt="" aria-hidden="true">';

  let $activeLoadingButton = null;
  let isFirstClick = true;

  function getFindationButton() {
    return $(findationButtonSelector);
  }

  function injectSpinnerIfReady() {
    const $findationButton = getFindationButton();

    if ($findationButton.length === 0) {
      return false;
    }

    if ($findationButton.find('.findation-loading-spinner').length === 0) {
      $findationButton.prepend(findationSpinnerMarkup);
    }

    return true;
  }

  function clearLoadingState() {
    if ($activeLoadingButton) {
      $activeLoadingButton.removeClass('is-loading').removeAttr('aria-busy').removeAttr('aria-disabled');
      $activeLoadingButton = null;
    }
  }

  function waitForFindationIframe(callback) {
    const iframe = document.getElementById('findation-iframe');
    if (iframe) {
      callback(iframe);
      return;
    }
    if (!window.MutationObserver || !document.body) {
      clearLoadingState();
      return;
    }

    const observer = new MutationObserver(function() {
      const iframe = document.getElementById('findation-iframe');
      if (!iframe) {
        return;
      }
      clearTimeout(timeoutId);
      observer.disconnect();
      callback(iframe);
    });
    const timeoutId = setTimeout(function() {
      observer.disconnect();
      clearLoadingState();
    }, 5000);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // Detect and inject spinner into CTA button on initial load.
  if (!injectSpinnerIfReady()) {
    if (window.MutationObserver && document.body) {
      const buttonObserver = new MutationObserver(function() {
        if (injectSpinnerIfReady()) {
          buttonObserver.disconnect();
        }
      });

      const timeoutId = setTimeout(function() {
        buttonObserver.disconnect();
      }, 3000);

      buttonObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  // Handle iframe detection and loading state on button click.
  ServiceBus.on(Topics.events.FINDATION_BUTTON_CLICKED,
    function(payload) {
      if (payload && isFirstClick && !$activeLoadingButton) {
        $activeLoadingButton = getFindationButton();
        $activeLoadingButton.addClass('is-loading').attr('aria-busy', 'true').attr('aria-disabled', 'true');

        waitForFindationIframe(function(iframe) {
          const loadTimeout = setTimeout(clearLoadingState, 30000);

          $(iframe).one('load', function() {
            clearTimeout(loadTimeout);
            clearLoadingState();
            isFirstClick = false;
          });
        });
      }
    }
  );

})(jQuery, Drupal, window.GlobalServiceBus || {}, window.ServiceBusTopics || {});
